import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@edvi-tech/ui/dialog'
import Controls from '../Controls/Controls'

/**
 * Confirm dialog — same props API as before, @edvi-tech/ui shell.
 */
export default function ConfirmDialog({
  open,
  setOpen,
  title,
  content,
  yesAction,
  noAction,
  acceptButton,
  rejectButton,
  videoControl,
  wide = false,
}) {
  const handleClose = () => setOpen(false)

  const handleRefresh = () => {
    handleClose()
    window.location.reload()
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) handleClose()
      }}
    >
      <DialogContent
        className={`${
          wide ? 'edvi-dlg-content' : 'edvi-dlg-content--sm'
        } gap-0 overflow-hidden rounded-2xl border-[#eef0f6] p-0`}
      >
        <DialogHeader className="space-y-1 px-6 pb-4 pt-6 text-center sm:text-center">
          <DialogTitle className="text-xl font-semibold text-[#1c2434]">
            {title}
          </DialogTitle>
          {typeof content === 'string' ? (
            <DialogDescription className="text-[15px] leading-relaxed text-[#4b5563]">
              {content}
            </DialogDescription>
          ) : content ? (
            <div className="text-left text-[15px] leading-relaxed text-[#4b5563]">
              {content}
            </div>
          ) : null}
        </DialogHeader>

        <DialogFooter className="flex-col gap-2 border-t border-[#eef0f6] bg-[#fbfbfe] px-6 py-4 sm:flex-col">
          {(yesAction || acceptButton) && (
            <Controls.Button
              size="large"
              text={acceptButton || 'YES'}
              onClick={() => {
                yesAction?.()
                handleClose()
              }}
              className="bg-[#585858] hover:bg-[#4a4a4a]"
            />
          )}
          <Controls.Button
            size="large"
            text={rejectButton || 'NO'}
            onClick={
              videoControl
                ? handleRefresh
                : () => {
                    noAction?.()
                    handleClose()
                  }
            }
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
